import { isAllowed42CFRP2Email } from "../helpers/predicates";
import type { PermissionConfig, PermissionKey } from "../types";

import { ACUITY_PERMISSIONS } from "./permissions/acuity";

export const PERMISSION_LIST: Record<PermissionKey, PermissionConfig> = {
  patientDiagnosis: {
    allowIf: isAllowed42CFRP2Email,
    description: "Access to view patient diagnosis information",
    excludedRoles: ["provider:pcp"],
  },
  reports: {
    allowIf: isAllowed42CFRP2Email,
    description: "Access to reports and analytics",
    excludedRoles: ["provider:pcp"],
  },
  screening: {
    allowIf: isAllowed42CFRP2Email,
    description: "Access to A5 Screening tab",
    excludedRoles: ["provider:pcp"],
  },
  ...ACUITY_PERMISSIONS,
};
